export const GEO_OBJECT_TYPE_GET_REQUEST = 'GEO_OBJECT_TYPE_GET_REQUEST';
export const GEO_OBJECT_TYPE_GET_SUCCESS = 'GEO_OBJECT_TYPE_GET_SUCCESS';
export const GEO_OBJECT_TYPE_GET_ERROR = 'GEO_OBJECT_TYPE_GET_ERROR';
export const GEO_OBJECT_TYPE_GET_BY_KEY_REQUEST = 'GEO_OBJECT_TYPE_GET_BY_KEY_REQUEST';
export const GEO_OBJECT_TYPE_GET_BY_KEY_SUCCESS = 'GEO_OBJECT_TYPE_GET_BY_KEY_SUCCESS';
export const GEO_OBJECT_TYPE_GET_BY_KEY_ERROR = 'GEO_OBJECT_TYPE_GET_BY_KEY_ERROR';
export const GEO_OBJECT_TYPE_ADD_REQUEST = 'GEO_OBJECT_TYPE_ADD_REQUEST';
export const GEO_OBJECT_TYPE_ADD_SUCCESS = 'GEO_OBJECT_TYPE_ADD_SUCCESS';
export const GEO_OBJECT_TYPE_ADD_ERROR = 'GEO_OBJECT_TYPE_ADD_ERROR';
export const GEO_OBJECT_TYPE_EDIT_REQUEST = 'GEO_OBJECT_TYPE_EDIT_REQUEST';
export const GEO_OBJECT_TYPE_EDIT_SUCCESS = 'GEO_OBJECT_TYPE_EDIT_SUCCESS';
export const GEO_OBJECT_TYPE_EDIT_ERROR = 'GEO_OBJECT_TYPE_EDIT_ERROR';
export const GEO_OBJECT_TYPE_DELETE_REQUEST = 'GEO_OBJECT_TYPE_DELETE_REQUEST';
export const GEO_OBJECT_TYPE_DELETE_SUCCESS = 'GEO_OBJECT_TYPE_DELETE_SUCCESS';
export const GEO_OBJECT_TYPE_DELETE_ERROR = 'GEO_OBJECT_TYPE_DELETE_ERROR';
